import React, { useEffect, useRef } from 'react';
import { partners } from '../../data/mock';

const PartnersSection = () => {
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('active');
          }
        });
      },
      { threshold: 0.1 }
    );

    const elements = sectionRef.current?.querySelectorAll('.reveal');
    elements?.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="reveal text-center mb-10">
          <p className="text-sm font-semibold text-gray-400 uppercase tracking-wider">Trusted By Industry Leaders</p>
        </div>
        
        <div className="reveal delay-100 flex flex-wrap items-center justify-center gap-x-12 gap-y-8">
          {partners.slice(0, 6).map((partner, index) => (
            <div
              key={index}
              className="flex items-center justify-center h-12 px-6 grayscale hover:grayscale-0 opacity-50 hover:opacity-100 transition-all duration-300"
            >
              <span className="text-xl font-bold text-gray-400 hover:text-gray-700 transition-colors">{partner.name}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PartnersSection;
